import {JsonProperty} from '@hyperloris/tyson';
import {Trade} from "../trade";
import {AccountDefinition} from "../../customer/account-definition";
import CallPut = Trade.CallPut;
import Side = Trade.Side;
import {AllocationSplitRequest} from "./allocation-split-request";
import {DateTime} from "luxon";

export class AllocationRequest {

  @JsonProperty()
  owner: string | undefined;

  @JsonProperty()
  clearingHouse: string | undefined;

  @JsonProperty()
  exchangeCode: string | undefined;

  @JsonProperty()
  orderReference: string | undefined;

  @JsonProperty()
  apsGroupId: string | undefined;

  @JsonProperty()
  customerName: string | undefined;
  customerId: string | undefined;

  @JsonProperty()
  tradeIds: string[];

  @JsonProperty()
  orderIds: string[];

  @JsonProperty()
  comment: string | undefined;

  @JsonProperty()
  accountCode: string | undefined;

  @JsonProperty()
  accountTypeCode: string | undefined;

  @JsonProperty()
  reference1: string | undefined;

  @JsonProperty()
  reference2: string | undefined;

  @JsonProperty()
  reference3: string | undefined;

  @JsonProperty()
  giveUpBrokerCode: string | undefined;

  @JsonProperty()
  giveUpMessage: string | undefined;

  @JsonProperty()
  giveUpMessage2: string | undefined;

  @JsonProperty()
  giveUpMessage3: string | undefined;

  @JsonProperty()
  broker: string | undefined;

  @JsonProperty()
  giveupAccountType: string | undefined;

  @JsonProperty()
  traderMemo: string | undefined;

  @JsonProperty()
  giveUpCommission: string | undefined;

  @JsonProperty()
  executionFee: string | undefined;

  @JsonProperty()
  openClose: AccountDefinition.OpenClose | undefined;

  @JsonProperty()
  callPut: CallPut | undefined;

  @JsonProperty()
  traderName: string | undefined;

  @JsonProperty()
  execTrader: string | undefined;

  @JsonProperty()
  moneyOwner: string | undefined;

  @JsonProperty()
  currency: string | undefined;

  @JsonProperty()
  rate?: number | undefined;

  @JsonProperty()
  businessDate: Date;
  @JsonProperty()
  clearingDate: Date;
  @JsonProperty()
  creationDate: Date = new Date();

  @JsonProperty()
  side: Side | undefined;

  @JsonProperty()
  customOrderReference: string | undefined;

  @JsonProperty()
  tradingEnvironment: string | undefined;

  @JsonProperty()
  tradeType: string | undefined;

  @JsonProperty()
  contractCode: string | undefined;
  contractId: string | undefined;
  @JsonProperty()
  contractUnit: string | undefined;
  @JsonProperty()
  contractVersion: string | undefined;

  @JsonProperty()
  maturity: string | undefined;

  @JsonProperty()
  strike: number | undefined;

  @JsonProperty()
  volume: number | undefined;

  @JsonProperty()
  price: number | undefined;

  @JsonProperty()
  overrideApsPrice: number = 0;

  @JsonProperty()
  apsPrice: number = 0;

  @JsonProperty()
  apsRoundPrice: number = 0;

  @JsonProperty()
  desk: string | undefined;

  @JsonProperty()
  allocations: AllocationSplitRequest[] = [];



}

